function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19 4H5a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V5a1 1 0 00-1-1zm-5.133 1.85a.333.333 0 01.3-.183h2a.333.333 0 01.266.533l-1 1.333a.333.333 0 01-.533 0l-1-1.333a.333.333 0 01-.033-.35zm-6.3 1.283l1-1.333a.345.345 0 01.533 0l1 1.333a.333.333 0 01-.267.534h-2a.333.333 0 01-.266-.534zm3.766 11.2a.334.334 0 01-.333.334H6.667a.333.333 0 01-.334-.334V10c0-.184.15-.333.334-.333H11c.184 0 .333.149.333.333v8.333zm6.334 0c0 .184-.15.334-.334.334H13a.333.333 0 01-.333-.334V10c0-.184.149-.333.333-.333h4.333c.184 0 .334.149.334.333v8.333z"
});

function SvgElevator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgElevator;